import { Spinner } from '@cian/ui-kit';
import * as React from 'react';
import classNames from 'classnames';
import { useIsMobileDevice } from '../../hooks';
import * as styles from './LoadingOverlay.css';

export const LoadingOverlay = () => {
  const isMobile = useIsMobileDevice();

  return (
    <>
      <div className={styles['overlay']}></div>
      <div className={classNames(styles['loader'], isMobile && styles['centered'])}>
        <Spinner size={48} />
      </div>
    </>
  );
};
